import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    const buildingDamageArray: any = ['tag', 'hegn', 'drivhus', 'flagstang', 'andet (skorsten, vindue mv.)'];
    const buildingDamageArrayRoof: any = ['hus', 'garage', 'skur', 'udestue', 'anneks'];
    let selectedcheckboxes: Array<{ label: string; value: string }> = getValueOrDefault(
        formConfig,
        formValues,
        'lossDescription'
    );
    let selectedcheckboxesRoof: Array<{ label: string; value: string }> = getValueOrDefault(
        formConfig,
        formValues,
        'lossDescriptionRoof'
    );
    let selectedcheckboxesvalues = selectedcheckboxes.map((item) => item.value.toLowerCase());
    let selectedcheckboxesRoofvalues = selectedcheckboxesRoof.map((item) => item.value.toLowerCase());

    // Rearrange the order for selected checkboxes
    selectedcheckboxesvalues.sort((a: any, b: any) => buildingDamageArray.indexOf(a) - buildingDamageArray.indexOf(b));
    selectedcheckboxesRoofvalues.sort(
        (a: any, b: any) => buildingDamageArrayRoof.indexOf(a) - buildingDamageArrayRoof.indexOf(b)
    );

    // Find next page for selected checkboxes
    const getNextPageForSelectedCheckbox = (checkbox: string, nextPageId: string) => {
        const index = selectedcheckboxesvalues.indexOf(checkbox);
        return index < selectedcheckboxesvalues.length - 1 ? selectedcheckboxesvalues[index + 1] : nextPageId;
    };
    // Roof - tag
    const getNextPageForSelectedCheckboxRoof = (checkbox: string, nextPageId: string) => {
        const index = selectedcheckboxesRoofvalues.indexOf(checkbox);
        return index < selectedcheckboxesRoofvalues.length - 1 ? selectedcheckboxesRoofvalues[index + 1] : nextPageId;
    };

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;

        case 'adresse':
            nextPage = 'hvilke-skader';
            break;

        case 'hvilke-skader':
            if (selectedcheckboxesvalues.length > 0) {
                nextPage = selectedcheckboxesvalues[0];
            } else {
                nextPage = 'vedhaeft-filer';
            }
            break;

        // tag
        case 'tag':
            if (selectedcheckboxesRoofvalues.length > 0) {
                nextPage = selectedcheckboxesRoofvalues[0];
            } else {
                nextPage = 'vand-fugt';
            }
            break;

        // hus
        case 'hus':
            if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value === 'Sten (tegl)') {
                nextPage = 'hus-hvilke-sten';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value === 'Plastik') {
                nextPage = 'hus-plastik';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value === 'Plader') {
                nextPage = 'hus-plader';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value === 'Pap') {
                nextPage = 'hus-om-pap-tag';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value === 'Stråtag') {
                nextPage = 'hus-om-straa-tag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaHus').value ===
                'Andet (fx grønt tag, skifer mv.)'
            ) {
                nextPage = 'hus-om-andet-tag';
            } else {
                nextPage = 'vand-fugt';
            }

            break;

        // hus - sten
        case 'hus-hvilke-sten':
            nextPage = 'hus-om-taget';
            break;

        case 'hus-om-taget':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');

            break;

        // hus - plastik
        case 'hus-plastik':
            nextPage = 'hus-om-plastik-tag';
            break;

        case 'hus-om-plastik-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');
            break;

        // hus - plader
        case 'hus-plader':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');
            break;

        case 'hus-om-pap-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');
            break;

        // hus - stråtag
        case 'hus-om-straa-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');
            break;

        // hus - andet
        case 'hus-om-andet-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('hus', 'vand-fugt');
            break;

        // garage
        case 'garage':
            if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value === 'Sten (tegl)') {
                nextPage = 'garage-hvilke-sten';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value === 'Plastik'
            ) {
                nextPage = 'garage-plastik-tag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value === 'Plader'
            ) {
                nextPage = 'garage-plader';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value === 'Pap') {
                nextPage = 'garage-om-pap';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value === 'Stråtag'
            ) {
                nextPage = 'garage-om-straa-tag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagGarage').value ===
                'Andet (fx grønt tag, skifer mv.)'
            ) {
                nextPage = 'garage-andet-tag';
            } else {
                nextPage = 'vand-fugt';
            }
            break;

        // garage - sten
        case 'garage-hvilke-sten':
            nextPage = 'garage-teglsten';
            break;
        case 'garage-teglsten':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;

        // garage - plastik
        case 'garage-plastik-tag':
            nextPage = 'garage-plastik-tag-kvm';
            break;

        case 'garage-plastik-tag-kvm':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;

        // garage - plader
        case 'garage-plader':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;
        // garage - pap
        case 'garage-om-pap':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;
        // garage - stråtag
        case 'garage-om-straa-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;
        // garage - andet
        case 'garage-andet-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('garage', 'vand-fugt');
            break;

        // skur
        case 'skur':
            if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value === 'Sten (tegl)') {
                nextPage = 'skur-sten';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value === 'Plastik') {
                nextPage = 'skur-plastik';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value === 'Plader') {
                nextPage = 'skur-plader';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value === 'Pap') {
                nextPage = 'skur-om-eternit-tag';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value === 'Stråtag') {
                nextPage = 'skur-straa-tag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaSkur').value ===
                'Andet (fx grønt tag, skifer mv.)'
            ) {
                nextPage = 'skur-andet-tag';
            } else {
                nextPage = 'vand-fugt';
            }
            break;

        // skur - sten
        case 'skur-sten':
            nextPage = 'skur-om-taget';
            break;
        case 'skur-om-taget':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // skur - plastik
        case 'skur-plastik':
            nextPage = 'skur-om-plastik-tag';
            break;

        case 'skur-om-plastik-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // skue - plader
        case 'skur-plader':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // skur - pap
        case 'skur-om-eternit-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // skur - stråtag
        case 'skur-straa-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // skur - andet
        case 'skur-andet-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('skur', 'vand-fugt');
            break;

        // udestue
        case 'udestue':
            if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value ===
                'Sten (tegl)'
            ) {
                nextPage = 'udestue-sten';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value ===
                'Plastik'
            ) {
                nextPage = 'udestue-plastik';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value === 'Plader'
            ) {
                nextPage = 'udestue-plader';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value === 'Pap'
            ) {
                nextPage = 'udestue-tagpap';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value ===
                'Stråtag'
            ) {
                nextPage = 'udeskur-straa-tag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpbygningenTagUdestuen').value ===
                'Andet (fx grønt tag, skifer mv.)'
            ) {
                nextPage = 'udestue-andet-tag';
            } else {
                nextPage = 'vand-fugt';
            }
            break;

        // udestue - sten
        case 'udestue-sten':
            nextPage = 'udestue-om-taget';
            break;
        case 'udestue-om-taget':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // udestue - plastik
        case 'udestue-plastik':
            nextPage = 'udestue-plastik-tag-kvm';
            break;

        case 'udestue-plastik-tag-kvm':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // udestue - plader
        case 'udestue-plader':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // udestue - pap
        case 'udestue-tagpap':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // udestue - stråtag
        case 'udeskur-straa-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // udestue - andet
        case 'udestue-andet-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('udestue', 'vand-fugt');
            break;

        // anneks
        case 'anneks':
            if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value === 'Sten (tegl)') {
                nextPage = 'anneks-sten';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value === 'Plastik'
            ) {
                nextPage = 'anneks-pastik';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value === 'Plader'
            ) {
                nextPage = 'anneks-plader';
            } else if (getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value === 'Pap') {
                nextPage = 'anneks-tagpap';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value === 'Stråtag'
            ) {
                nextPage = 'anneks-straatag';
            } else if (
                getValueOrDefault(formConfig, formValues, 'hvilkentagtypeerderpaaTagAnneks').value ===
                'Andet (fx grønt tag, skifer mv.)'
            ) {
                nextPage = 'anneks-andet-tag';
            } else {
                nextPage = 'vand-fugt';
            }
            break;

        // anneks - sten
        case 'anneks-sten':
            nextPage = 'anneks-om-taget';
            break;
        case 'anneks-om-taget':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // anneks - plastik
        case 'anneks-pastik':
            nextPage = 'anneks-plastik-tag-kvm';
            break;

        case 'anneks-plastik-tag-kvm':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // anneks - plader
        case 'anneks-plader':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // anneks - pap
        case 'anneks-tagpap':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // anneks - stråtag
        case 'anneks-straatag':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // anneks - andet
        case 'anneks-andet-tag':
            nextPage = getNextPageForSelectedCheckboxRoof('anneks', 'vand-fugt');
            break;

        // tag default
        case 'vand-fugt':
            nextPage = 'liftleje';
            break;

        case 'liftleje':
            nextPage = 'reparation-tag';
            break;

        case 'reparation-tag':
            if (getValueOrDefault(formConfig, formValues, 'vilduselvrepareretaget').value === 'no') {
                nextPage = 'tag-indhentning-af-tilbud';
            } else {
                nextPage = getNextPageForSelectedCheckbox('tag', 'vedhaeft-filer');
                break;
            }
            break;

        case 'tag-indhentning-af-tilbud':
            nextPage = getNextPageForSelectedCheckbox('tag', 'vedhaeft-filer');
            break;

        //hegn
        case 'hegn':
            nextPage = 'om-hegnet';
            break;

        case 'om-hegnet':
            if (getValueOrDefault(formConfig, formValues, 'varhegnetsatfastijorden').value === 'Ja') {
                nextPage = 'type-hegn';
            } else {
                nextPage = getNextPageForSelectedCheckbox('hegn', 'vedhaeft-filer');
                break;
            }
            break;

        case 'type-hegn':
            nextPage = 'montering';
            break;

        case 'montering':
            if (getValueOrDefault(formConfig, formValues, 'vilduselvmonteredetnyehegn').value === 'Nej') {
                nextPage = 'haandvaerker';
            } else {
                nextPage = getNextPageForSelectedCheckbox('hegn', 'vedhaeft-filer');
                break;
            }
            break;

        case 'haandvaerker':
            nextPage = getNextPageForSelectedCheckbox('hegn', 'vedhaeft-filer');
            break;

        //drivhus
        case 'drivhus':
            if (getValueOrDefault(formConfig, formValues, 'vardrivhusetfastmonteretdaskadenskete').value === 'Ja') {
                nextPage = 'drivhus-glas';
            } else {
                nextPage = getNextPageForSelectedCheckbox('drivhus', 'vedhaeft-filer');
                break;
            }
            break;

        case 'drivhus-glas':
            if (getValueOrDefault(formConfig, formValues, 'erderkunskaderpdrivhusetsglas').value === 'Ja') {
                nextPage = 'drivhus-glasstoerrelse';
            } else {
                nextPage = getNextPageForSelectedCheckbox('drivhus', 'vedhaeft-filer');
                break;
            }
            break;

        case 'drivhus-glasstoerrelse':
            nextPage = 'drivhus-andre-materialer';
            break;

        case 'drivhus-andre-materialer':
            nextPage = 'drivhus-montering';
            break;

        case 'drivhus-montering':
            if (getValueOrDefault(formConfig, formValues, 'vilduselvmontereglassetDrivhus').value === 'Nej') {
                nextPage = 'drivhus-indhentning-af-tilbud';
            } else {
                nextPage = 'eventuelle-kommentarer';
                break;
            }
            break;

        case 'drivhus-indhentning-af-tilbud':
            if (getValueOrDefault(formConfig, formValues, 'harduindhentettilbudfraenhndvrkerdrivhus').value === 'Ja') {
                nextPage = 'drivhus-om-tilbuddet';
            } else {
                nextPage = 'eventuelle-kommentarer';
                break;
            }
            break;

        case 'drivhus-om-tilbuddet':
            nextPage = 'eventuelle-kommentarer';
            break;

        case 'eventuelle-kommentarer':
            nextPage = getNextPageForSelectedCheckbox('drivhus', 'vedhaeft-filer');
            break;

        //flagstang
        case 'flagstang':
            if (getValueOrDefault(formConfig, formValues, 'erflagstangenknkket').value === 'Ja') {
                nextPage = 'flagstang-skade';
            } else {
                nextPage = getNextPageForSelectedCheckbox('flagstang', 'vedhaeft-filer');
            }
            break;

        case 'flagstang-skade':
            nextPage = 'om-flagstangen';
            break;

        case 'om-flagstangen':
            nextPage = 'flagstang-højde';
            break;

        case 'flagstang-højde':
            nextPage = 'flagstang-montering';
            break;

        case 'flagstang-montering':
            nextPage = getNextPageForSelectedCheckbox('flagstang', 'vedhaeft-filer');
            break;

        //Andet
        case 'andet (skorsten, vindue mv.)':
            nextPage = getNextPageForSelectedCheckbox('andet (skorsten, vindue mv.)', 'vedhaeft-filer');
            break;

        //Default
        case 'vedhaeft-filer':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'resume';
            }
            break;

        case 'hvilket-selskab':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
